module.exports = __webpack_public_path__ + "static/img/bgi3.17f04c63.jpg";